import React from "react";
import Modal from "react-modal";
import DateTimePicker from "react-datepicker";
import NumberFormat from "react-number-format";
import ValidatedInput from "../../../shared/ValidatedInput";
import Checkbox from "../../../shared/Checkbox";
import { removeTimezoneFormatFromDate } from "../../../../lib";
import _cloneDeep from "lodash.clonedeep";
import _isEqual from "lodash.isequal";
import moment from "moment";

const defaultSchedule = {
  maximumParticipants: "",
  name: "",
  time: "",
  groupSize: "",
  allowedTransportationOptions: [],
};

export default class TourScheduleModal extends React.PureComponent {
  constructor(props) {
    super(props);

    const { ohelTourTransportationOptions = [], schedule } = props;

    // default all transportation options to checked when creating a new schedule
    const editableState = {
      schedule: schedule
        ? { ...schedule }
        : {
            ...defaultSchedule,
            allowedTransportationOptions: ohelTourTransportationOptions.map(
              (option) => option.enumValue,
            ),
          },
      submitAttempted: false,
    };

    this.state = {
      ...editableState,
      initialState: _cloneDeep(editableState),
    };
  }

  onChangeSchedule = (name, value) => {
    this.setState({
      schedule: {
        ...this.state.schedule,
        [name]: value,
      },
    });
  };

  onToggleTransOption = (enumValue) => {
    const { allowedTransportationOptions = [] } = this.state.schedule;
    const updatedOptions = allowedTransportationOptions.includes(enumValue)
      ? allowedTransportationOptions.filter((o) => o !== enumValue)
      : [...allowedTransportationOptions, enumValue];

    this.onChangeSchedule("allowedTransportationOptions", updatedOptions);
  };

  onClose = () => {
    this.props.close();
  };

  onSave = () => {
    this.setState(
      {
        submitAttempted: true,
      },
      () => {
        const { hasTransportation, isOhelTour } = this.props;
        const {
          schedule: { name, time, allowedTransportationOptions = [] },
        } = this.state;

        if (!name || !time) {
          return;
        }

        // Ohel schedules with transportation must offer at least one transportation option
        if (
          isOhelTour &&
          hasTransportation &&
          !allowedTransportationOptions.length
        ) {
          return;
        }

        this.props.save(this.state.schedule);

        this.onClose();
      },
    );
  };

  render() {
    const {
      hasStartedShluchimEnrollment,
      hasTransportation,
      isOhelTour,
      ohelTourTransportationOptions,
      schedule: scheduleForEdit,
      tripEndDate,
      tripStartDate,
    } = this.props;

    const {
      initialState: { schedule: initialSchedule },
      schedule,
      schedule: {
        id: scheduleId,
        maximumParticipants,
        name,
        time,
        groupSize,
        allowedTransportationOptions = [],
      },
      submitAttempted,
    } = this.state;

    return (
      <Modal
        isOpen={true}
        className="new-schedule-modal-container modal-container"
      >
        <div className="modal-card card new-schedule-modal">
          <p className="large-text fw-500 mb-16">
            {!scheduleForEdit ? "New" : "Edit"} Schedule
          </p>
          <div className="flex flex-align-center flex-justify-space mb-12 mr-32">
            <label className="accent-text-dark">Name</label>
            <ValidatedInput
              input={<input type="text" className="schedule-modal-input" />}
              name="name"
              onChange={(e) =>
                this.onChangeSchedule(e.target.name, e.target.value)
              }
              required={true}
              showRequired={submitAttempted}
              value={name}
            />
          </div>
          <div className="flex flex-align-center flex-justify-space mb-12 mr-32">
            <label className="accent-text-dark">Date & Time</label>
            <DateTimePicker
              className={`custom-input schedule-modal-input ${
                submitAttempted && !time ? "error" : ""
              }`} //= required={true}
              dateFormat="MM/DD/YYYY h:mm a"
              maxDate={moment(tripEndDate)}
              minDate={moment(tripStartDate)}
              name="time"
              onChange={(date) =>
                this.onChangeSchedule(
                  "time",
                  removeTimezoneFormatFromDate(date),
                )
              }
              selected={time ? moment(time) : null}
              showTimeSelect={true}
              timeIntervals={1}
            />
          </div>
          <div className="flex flex-align-center flex-justify-space mb-12 mr-32">
            <label className="accent-text-dark">
              Max Capacity{" "}
              <span className="accent-text xs-text">(optional)</span>
            </label>
            <NumberFormat
              className="custom-input small-input"
              name="maximumParticipants"
              onChange={(e) =>
                this.onChangeSchedule(e.target.name, e.target.value)
              }
              value={maximumParticipants}
              type="text"
              allowNegative={false}
              decimalScale={0}
            />
          </div>
          <div className="flex flex-align-center flex-justify-space mb-16 mr-32">
            <label className="accent-text-dark">
              Group Size <span className="accent-text xs-text">(optional)</span>
            </label>
            <NumberFormat
              className="custom-input small-input"
              name="groupSize"
              onChange={(e) =>
                this.onChangeSchedule(e.target.name, e.target.value)
              }
              value={groupSize}
              allowNegative={false}
              decimalScale={0}
            />
          </div>
          {isOhelTour && hasTransportation && (
            <div className="flex mb-16 mr-32">
              <label className="accent-text-dark mr-32">Return Options</label>
              <div>
                {ohelTourTransportationOptions.map((option) => (
                  <Checkbox
                    className="mb-12"
                    key={option.enumValue}
                    checked={allowedTransportationOptions.includes(
                      option.enumValue,
                    )}
                    label={option.displayValue}
                    name={option.enumValue}
                    onChange={() => this.onToggleTransOption(option.enumValue)}
                  />
                ))}
                {submitAttempted && !allowedTransportationOptions.length && (
                  <span className="error-text">
                    At least one transportation option is required
                  </span>
                )}
              </div>
            </div>
          )}
          {!!(
            hasStartedShluchimEnrollment &&
            scheduleId &&
            initialSchedule.time !== time
          ) && (
            <span className="error-text ml-8">
              <i className="material-icons large-text">warning</i>
              <span className="ml-8">
                Note that event registration has started, and shluchim and/or
                students may be enrolled in this tour. Please beware of the fact
                that changing the schedule date or time may cause conflicts in
                enrollees' schedules.
              </span>
            </span>
          )}
          <div className="modal-btns flex flex-align-center flex-justify-end mt-16">
            <button
              className="btn link-text uppercase-text fw-500"
              onClick={this.onClose}
            >
              Cancel
            </button>
            <button
              className="btn link-text uppercase-text fw-500 ml-24"
              disabled={_isEqual(initialSchedule, schedule)}
              onClick={this.onSave}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
